import React, { useContext, useEffect } from 'react'
import { NavigationContext } from '../context/NavigationContext';
import Button from '../components/Button';
import Badge from '../components/Badge';

const PagePresentation = () => {

    const { setPage, hideMenu } = useContext(NavigationContext)

    useEffect(() => {
        setPage('presentation')
        hideMenu()
        window.scrollTo(0, 1)
    }, [])

    return (
        <div>
            <h1>Bienvenue sur le site de présentation de l’UV NF05 !</h1>
            <p>NF05 est une UV destinée à vous préparer à la <b>certification Pix.</b></p>
            <p>La certification Pix, est une certification française dispensée dans les universités pour attester de compétences dans la maîtrise des outils informatiques et réseaux. Cet enseignement permet d’acquérir des compétences dans la maîtrise des outils informatiques, des technologies de l’information et de la communication, des réseaux, des aspects juridiques et éthiques associés à l’internet, et de la recherche d’information sur le web, ainsi que la publication de données sur internet.</p>
            <p>La certification Pix <b>remplace la certification C2i</b>.</p>
            <div className="badge-container">
                <Badge icon="certification" title="UV certifiante" description="La certification Pix est associée à l'UV" />
                <Badge icon="computer" title="Cours à distance" description="Certains cours sont sur Moodle et le site de Pix" />
                <Badge icon="people" title="Cours en présence" description="5 x 4h de TP à l’UTC" />
            </div>
            <p>Obtenez plus d’informations en cliquant sur le bouton ci-dessous.</p>
            <Button align="center" icon="arrow-right" to="?page=modalites">Modalités de l'UV</Button>
        </div>
    );
}

export default PagePresentation;